import { SystemBase2 } from "@inter-ikea-core/core-toolbox";
import { ComponentIds, } from "@inter-ikea-core/core";
import { updateStabilityZoneComponentInSection } from "../functions/stability";
import { COMPONENT_IDS } from "../storage2ComponentIDs";
export class StabilitySystem extends SystemBase2 {
    constructor(entityManager) {
        super(ComponentIds.IN_SCENE_COMPONENT_ID, ComponentIds.HOST_CONNECTIONS_COMPONENT_ID);
        this.entityManager = entityManager;
        this.doingChangesOnComponent = [];
        this.id = "StabilitySystem";
        this.systemsAfterMe = null;
        this.systemsBeforeMe = null;
    }
    onAddComponent(_entity, _newComponent) {
        const isSection = _entity.hasComponent(COMPONENT_IDS.SECTION_COMPONENT);
        isSection && updateStabilityZoneComponentInSection(_entity);
    }
    onUpdateComponent(_entity, _oldComponent, _newComponent) { }
    onRemoveComponent(_entity, _oldComponent) { }
    onAddComponent2(_entity, _newComponent) {
        updateStabilityZoneComponentInSection(_entity);
    }
    onUpdateComponent2(_entity, _oldComponent, _newComponent) {
        updateStabilityZoneComponentInSection(_entity);
    }
    onRemoveComponent2(_entity, _oldComponent) {
        updateStabilityZoneComponentInSection(_entity);
    }
}
